import { render } from "./GridCertificateMedicale.vue?vue&type=template&id=6d4bba33&ts=true"
import script from "./GridCertificateMedicale.vue?vue&type=script&lang=ts"
export * from "./GridCertificateMedicale.vue?vue&type=script&lang=ts"

import "./GridCertificateMedicale.vue?vue&type=style&index=0&id=6d4bba33&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__